import { render } from "./SongQueueComponent.vue?vue&type=template&id=f54b043c"
import script from "./SongQueueComponent.vue?vue&type=script&lang=ts"
export * from "./SongQueueComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script